// The suggested questions for the boat's mode, in one row above the message
// box (TOM-741): in the chat that slides in over a desktop page, as the iPad's
// chat has them over its box, and in the chat a phone's sparkle opens
// (TOM-817). A question fills the box and the owner sends it; it never sends
// by itself.

export function NeoSuggestions({
  questions,
  onPick,
  className,
  itemClassName,
  testId,
}: {
  questions: readonly string[];
  onPick: (question: string) => void;
  className: string;
  itemClassName: string;
  testId: string;
}) {
  if (questions.length === 0) return null;
  return (
    <ul className={className} aria-label="Suggested questions">
      {questions.map((question) => (
        <li key={question}>
          <button
            type="button"
            className={itemClassName}
            data-testid={testId}
            onClick={() => onPick(question)}
          >
            {question}
          </button>
        </li>
      ))}
    </ul>
  );
}
